/* eslint-disable prettier/prettier */
import React from 'react';
import ActivitySection from './ActivitySection';

import { useAdminActionCenter } from '../../../../hooks/useAdminActionCenter';

import userIcon from '../../../../assets/profile/dd1.png';
import eyeIcon from '../../../../assets/profile/dd2.png';
import programIcon from '../../../../assets/profile/dd3.png';
import deleteIcon from '../../../../assets/profile/dd4.png';
import eye from '../../../../assets/profile/View.png';

import styles from './DashboardActivity.module.css';
import { useNavigate } from 'react-router-dom';

const DashboardActivity = () => {
	const navigate = useNavigate();

	const {
		data,
		loading,
		error,

		recentActivityData,
		recentActivityLoading,
		recentActivityError,
	} = useAdminActionCenter();

	const getTitle = (count: number | undefined, label: string) => {
		return count && count > 0 ? `${count} ${label}` : `No ${label}`;
	};

	return (
		<div className={styles.wrapper}>
			{/* LEFT SECTION */}
			<div className={styles.left}>
				<ActivitySection
					title="Action Center"
					items={[
						{
							leftIcon: userIcon,
							leftIconBg: '#DFF5EF',
							title: getTitle(
								data?.pendingapprovals,
								'Requests Pending'
							),
							rightIcon: eye,
							onRightClick: () =>
								navigate('/dashboard/manageUsers'),
						},
						{
							leftIcon: userIcon,
							leftIconBg: '#DFF5EF',
							title: getTitle(
								data?.inactiveusers,
								'Users Inactive'
							),
							rightIcon: eye,
							onRightClick: () =>
								navigate('/dashboard/manageUsers'),
						},
						{
							leftIcon: eyeIcon,
							leftIconBg: '#E8F1FD',
							title: getTitle(data?.opentickets, 'Open Tickets'),
							rightIcon: eye,
						},
						{
							leftIcon: userIcon,
							leftIconBg: '#FFF4E5',
							title: getTitle(
								data?.expiringinvites,
								'Expiring Invites'
							),
							rightIcon: eye,
							onRightClick: () =>
								navigate('/dashboard/manageUsers'),
						},
						{
							leftIcon: programIcon,
							leftIconBg: '#F8E8F2',
							title: getTitle(
								data?.pendingreviews,
								'Pending Reviews'
							),
							rightIcon: eye,
						},
						{
							leftIcon: deleteIcon,
							leftIconBg: '#FDEBEC',
							title: getTitle(
								data?.unassignedcoachees,
								'Unassigned Learner'
							),
							rightIcon: eye,
							onRightClick: () =>
								navigate('/dashboard/manageUsers'),
						},
					]}
					containerBg="#fff"
					maxHeight="340px"
				/>
			</div>

			{/* RIGHT SECTION */}
			<div className={styles.right}>
				<ActivitySection
					title="Recent Activity"
					items={
						recentActivityData?.items?.map((item: any) => ({
							leftIcon:
								item.activitytype === 'course-created'
									? programIcon
									: deleteIcon,

							leftIconBg:
								item.activitytype === 'course-created'
									? '#F8E8F2'
									: '#FDEBEC',

							title: item.description,

							rightText: new Date(
								item.createdat
							).toLocaleDateString(),
						})) || []
					}
					containerBg="#fff"
					maxHeight="340px"
				/>
			</div>
		</div>
	);
};

export default DashboardActivity;
